<template>
  <div id="contact" class="contact-footer">
    <div class="container py-5 text-start text-white col">
      <p class="h4 fw-bold">{{$t('contact.company')}}</p>
      <p class="mt-3">{{$t('contact.country')}}</p>
      <p>{{$t('contact.address')}}</p>
      <p>{{$t('contact.phone')}}: 
        <a href="tel:+886-3327-0080" style="color: white;">+886 3 327-0080</a>
      </p>
      <p>Email: 
        <a href="mailto: info@myguard.com" style="color: white;">info@myguard.com</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactFooter'
}
</script>

<style scoped>
.contact-footer {
  background: linear-gradient(90deg, #137bba 0%, #5fa4b8 100%);
}
</style>
